//text == name,size = 18,type == icon,name == content,children == children
export default function menuTree(treeRes){
    let menuArr = [];
    const fatherTree = treeRes.filter(m => m.type == 'menu' && !m.resource_pid)
    for(let f of fatherTree){
        if(f.is_disabled == 0 || !f.is_disabled){
            let fobj = {}
            fobj.id = f.id
            fobj.text = f.name;
            fobj.size = 18;
            fobj.type = f.icon;
            fobj.name = f.code
            fobj.children = changeFirstMenu(f.children)
            menuArr.push(fobj)
        }
    }
    return menuArr;
}
//一级目录转化
function changeFirstMenu(first){
    const childrenTree = first.filter(c => c.type == 'menu')
    let childrenArr = []
    if(childrenTree.length == 0){
        return null;
    }
    for(let c of childrenTree){
        if(!c.is_disabled || c.is_disabled == 0){
            let cobj = {}
            cobj.id = c.id
            cobj.name = c.code;
            if(c.icon){
                cobj.type = c.icon;
                cobj.size = 18
            }
            cobj.text = c.name
            if(c.children){
                cobj.children = changeFirstMenu(c.children)
            }
            childrenArr.push(cobj)
        }
    }
    return childrenArr
}




// WEBPACK FOOTER //
// ./src/utils/treeMenu.js